<!-- .block-features -->
<div class="block block-features block-features--layout--{{ layout }}" *ngIf="features?.length">
    <div class="container">
        <div class="block-features__list">
            <ng-container *ngFor="let feature of features; index as i">
                <div class="block-features__item">
                    <div class="block-features__icon">
                        <app-icon *ngIf="isIcon(feature.icon)" [name]="feature.icon" size="48"></app-icon>
                        <img *ngIf="!isIcon(feature.icon)" width="48" height="48" [src]="feature.icon">
                    </div>
                    <div class="block-features__content">
                        <div class="block-features__title">{{feature.title}}</div>
                        <div class="block-features__subtitle">{{feature.subtitle}}</div>
                    </div>
                </div>
                <div *ngIf="features.length - 1 != i" class="block-features__divider"></div>
            </ng-container>
        </div>
    </div>
</div>
<!-- .block-features / end -->
